export type TheoryBookmark = {
  id: string;
  title: string;
  addedAt: string;
};

function storageKey(userId: string): string {
  return `nn_theory_bookmarks_${userId}`;
}

export function readTheoryBookmarks(userId: string): TheoryBookmark[] {
  if (!userId) return [];

  try {
    const raw = localStorage.getItem(storageKey(userId));
    if (!raw) return [];

    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];

    return parsed
      .filter(
        (item): item is TheoryBookmark =>
          item != null &&
          typeof item === 'object' &&
          typeof (item as TheoryBookmark).id === 'string' &&
          typeof (item as TheoryBookmark).title === 'string'
      )
      .sort(
        (a, b) =>
          new Date(b.addedAt).getTime() - new Date(a.addedAt).getTime()
      );
  } catch {
    return [];
  }
}

function saveTheoryBookmarks(userId: string, list: TheoryBookmark[]): void {
  if (!userId) return;

  try {
    localStorage.setItem(storageKey(userId), JSON.stringify(list));
  } catch {
    // ignore
  }
}

export function isTheoryBookmarked(userId: string, topicId: string): boolean {
  if (!userId) return false;
  return readTheoryBookmarks(userId).some((b) => b.id === topicId);
}

export function toggleTheoryBookmark(
  userId: string,
  topic: { id: string; title: string }
): boolean {
  if (!userId) return false;

  const list = readTheoryBookmarks(userId);
  const index = list.findIndex((b) => b.id === topic.id);

  if (index >= 0) {
    list.splice(index, 1);
    saveTheoryBookmarks(userId, list);
    return false;
  }

  list.unshift({
    id: topic.id,
    title: topic.title,
    addedAt: new Date().toISOString(),
  });
  saveTheoryBookmarks(userId, list);
  return true;
}
